import styled from 'styled-components';
import { mq, px2rem } from '../../../stylesheets/tools';

const StyledBackToTop = styled.div`
  .back-to-top {
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 60;
    color: #000;
    background-color: #fff;
    border: 2px solid #000;
    height: ${px2rem('70px')};
    min-width: ${px2rem('70px')};
    padding: 0 ${px2rem('20px')};
    display: flex;
    justify-content: center;
    align-items: center;
    gap: ${px2rem('24px')};

    .back-to-top__title {
      ${mq('m', 'max')} {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border-width: 0;
      }

      ${mq('m')} {
        display: block;
        max-width: ${px2rem('120px')};
        margin-bottom: 0px;
        text-align: left;
      }
    }
  }
`;

export default StyledBackToTop;
